import { CsvCellValue, CsvColumn, CsvExportDefinition } from "./types";

export const UTF8_BOM = "\uFEFF";

export const escapeCsvCell = (value: CsvCellValue): string => {
  if (value === null || value === undefined) {
    return "";
  }

  const rawText = String(value);
  const text =
    typeof value === "string" && isSpreadsheetFormula(rawText)
      ? `'${rawText}`
      : rawText;
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

const isSpreadsheetFormula = (value: string): boolean =>
  /^[=+@\t\r]/.test(value) ||
  (/^-/.test(value) && value !== "-" && !/^-?\d+(\.\d+)?$/.test(value));

export const visibleColumns = <T>(
  definition: CsvExportDefinition<T>
): CsvColumn<T>[] =>
  definition.columns.filter(
    (column) =>
      column.visible !== false && column.source !== definition.id.source
  );

export const csvHeaders = <T>(definition: CsvExportDefinition<T>): string[] => [
  definition.id.header,
  ...visibleColumns(definition).map((column) => column.label)
];

export const serializeCsv = (
  headers: string[],
  rows: CsvCellValue[][]
): string =>
  [...[headers], ...rows]
    .map((row) => row.map(escapeCsvCell).join(","))
    .join("\r\n") + "\r\n";

export const withUtf8Bom = (csv: string): string => `${UTF8_BOM}${csv}`;
